import { DEEP_BLUE } from '@/components/ThemeContext/constants';

// Shared by the AI voice interview surfaces. They sit in unthemed roots (the
// application page, the candidate booking page), so the font is load-bearing.
export const FONT = 'Source Sans Pro, sans-serif';

export const FOCUS_OUTLINE = `2px solid ${DEEP_BLUE}`;

export const PILL_RADIUS = '999px';

// Every Scout Button on these surfaces takes buttonColor="purple" and this sx,
// which the wrapper applies after its own styles: a full pill, as :Recruit's
// buttons are, in place of the wrapper's 6px corners, with the purple focus
// ring in place of its SCOUT_BLUE one. The outline follows the radius.
export const aiButtonSx = {
  borderRadius: PILL_RADIUS,
  '&.MuiButtonBase-root:focus-visible': { outline: FOCUS_OUTLINE }
};
